(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/message/content.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/message/content.js'); "use strict";


(function (svs, gsap) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  class DialogContent extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.log = new svs.core.log.Logger('DialogContent');
      this.options = options;
      this.hasScrollbar = false;
      this.scrolledBottom = null;
      this.render();
    }

    addMessageRow(message, i) {
      const messageRow = document.createElement('div');
      messageRow.className += "dialog-message-row dialog-message-".concat(message.type);

      switch (message.type) {
        case svs.components.dialog.message.CHECKBOX:
          if (message.block) {
            messageRow.className += '-block';
          }

          messageRow.innerHTML = svs.ui.form.partials.checkbox({
            value: message.value,
            label: message.text,
            checked: message.checked || false,
            class: 'js-dialog-item-checkbox',
            id: message.id ? message.id : i
          });
          break;

        default:
          messageRow.innerHTML = message.text;
          break;
      }

      if (message.align) {
        messageRow.className += " ".concat(message.align);
      }

      return messageRow;
    }

    updateScrollPosition() {
      if (Math.ceil(this.el.scrollTop) >= this.el.scrollHeight - this.el.offsetHeight) {
        if (!this.scrolledBottom) {
          this.emit('contentBottom');
          this.scrolledBottom = true;
        }
      } else if (this.scrolledBottom === null || this.scrolledBottom) {
        this.emit('contentScrolling');
        this.scrolledBottom = false;
      }
    }

    addScrollListener() {
      this.el.onscroll = () => {
        this.updateScrollPosition();
      };
    }

    removeScrollListener() {
      this.el.onscroll = null;
    }

    testScrollArea() {
      if (this.el.scrollHeight - this.el.offsetHeight) {
        if (!this.hasScrollbar) {
          this.addScrollListener();
          this.hasScrollbar = true;
        }
      } else if (this.hasScrollbar) {
        this.removeScrollListener();
        this.hasScrollbar = false;
      }

      this.updateScrollPosition();
    }

    scrollToEnd() {
      const scrollToPosition = this.el.scrollHeight - this.el.offsetHeight;
      gsap.to(this.el, {
        duration: 0.3,
        scrollTop: scrollToPosition
      });
    }

    filterAcceptedMessages(m) {
      return m.text.length;
    }

    createButtonWrapper() {
      this.el = document.createElement('div');
      this.el.className += 'dialog-content js-dialog-content focus-default';
      this.el.tabIndex = -1;
    }

    addIcon() {
      if (this.options.icon) {
        this._icon = new svs.components.dialog.Icon(this.options.icon);
        this.el.appendChild(this._icon.el);
      }
    }

    createTextWrapper() {
      this._textEl = document.createElement('div');
      this._textEl.className += 'dialog-text';
      this.el.appendChild(this._textEl);
    }

    createTitle() {
      this._titleEl = document.createElement('div');
      this._titleEl.className += 'dialog-title';
      this._titleEl.innerHTML += this.options.title;

      this._textEl.appendChild(this._titleEl);
    }

    createMessageRows() {
      if (this.options.message) {
        const textRows = this.options.message.filter(this.filterAcceptedMessages);

        if (textRows) {
          this._messageEl = document.createElement('div');
          this._messageEl.className += 'dialog-message';

          this._textEl.appendChild(this._messageEl);

          this.el.className += ' dialog-content-scrollable';
          let rowAlignProp = false;
          textRows.forEach((message, i) => {
            if (message.align) {
              rowAlignProp = true;
            }

            this._messageEl.appendChild(this.addMessageRow(message, i));
          }); 

          if (textRows.length > 1 && !rowAlignProp) {
            this.el.className += ' dialog-text-left';
          }
        }
      }
    }

    render() {
      this.createButtonWrapper();
      this.addIcon();
      this.createTextWrapper();
      this.createTitle();
      this.createMessageRows();
    }

  }

  svs.components.dialog.Content = DialogContent;
})(svs, gsap);
 })(window);